// All of the SASS files are compiled down into this single site.css.
// The eventual goal is to get rid of the SASS dependency.
import '../../sass/site.css';

// Legacy pages that need to get ported.
import ErrorPage from './components/error-page';

 // DISABLED AS PART OF MODSY WIND DOWN WORK
// Pre-purchase / Legacy Style Quiz
// import OnboardingContain from './containers/onboarding-contain';
// import OnboardingStyleQuiz from './components/onboarding/style-quiz';
// import OnboardingStyleQuizResults from './components/onboarding/style-quiz-results';

import { WAREHOUSE_API_URL } from '../config';

const routes = [
  {
    path: '/stylequiz-results',
    component: ErrorPage
    // DISABLED AS PART OF MODSY WIND DOWN WORK
    // component: function () {
    //   return (
    //     <OnboardingContain>
    //       <OnboardingStyleQuizResults />
    //     </OnboardingContain>
    //   );
    // }
  },
  {
    path: '/stylequiz/:step',
    component: ErrorPage
     // DISABLED AS PART OF MODSY WIND DOWN WORK
    // component: function () {
    //   return (
    //     <OnboardingContain>
    //       <OnboardingStyleQuiz />
    //     </OnboardingContain>
    //   );
    // }
  },
  {
    path: '/stylequiz',
    component: ErrorPage
    // DISABLED AS PART OF MODSY WIND DOWN WORK
    // component: () => <Redirect to={'/stylequiz/room'} />
  },
  {
    path: '/404',
    component: ErrorPage
  },
  {
    path: '/admin*',
    component: () => {
      const pathname = window.location.pathname;
      const query = window.location.search;
      window.location.replace(`${WAREHOUSE_API_URL}${pathname}${query}`);
      return null;
    }
  }
];

export default routes;
